<template>
	<div class="content notFound">
		<section class="c_section" style="margin-top: 6rem">
			<div class="c_inner">
				<h1>404</h1>
				<img src="@/assets/img/common/icon_404.svg" alt="404" class="icon_404" />
				<div class="text_box">
					<h2>404 ERROR</h2>
					<p>존재하지 않는 주소를 입력하셨거나, 요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.</p>
				</div>
				<div class="btn_wrap">
					<router-link to="/home">
						<button type="button" class="c_btn-primary c_btn-mid">홈으로</button>
					</router-link>
				</div>
			</div>
		</section>
	</div>
</template>

<script setup></script>

<style scoped>
	.notFound {
		display: flex;
		text-align: center;
		font-weight: var(--font-w-bold);
	}

	.notFound .c_inner {
		display: flex;
		align-items: center;
		flex-direction: column;
		gap: var(--space-xx-large);
	}
	.notFound .icon_404 {
		width: 50%;
		max-width: 16rem;
	}
	.notFound h1 {
		display: none;
		font-size: var(--font-size-xxx-large);
		margin-bottom: 2rem;
	}
	.notFound .text_box {
		display: flex;
		flex-direction: column;
		gap: var(--space-mid);
	}
	.notFound .text_box h2 {
		color: var(--font-color-sub);
		font-size: var(--font-size-xxx-large);
	}
	.notFound .text_box p {
		font-size: var(--font-size-large);
		font-weight: var(--font-w-regular);
		line-height: 1.4;
		letter-spacing: -1px;
		word-break: keep-all;
	}
	.notFound button {
		max-width: 30rem;
	}
	.notFound svg {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: auto;
		margin-bottom: -1rem;
	}
</style>
